import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

import { jsGrid } from "./jsGrid"
import RefreshableInterface from "../utils/RefreshableInterface";
import {OpenDialog} from "../../index";

interface GridProps {

}

@Dce("Grid")
export default class Grid extends DceComponent<GridProps> implements RefreshableInterface{

    private element: JQuery<HTMLElement>;

    private grid: jsGrid;

    private selectedChangeCallbacks: ((ids: any[]) => void)[] = [];

    constructor(elem: DceHTMLElement, props: GridProps | null) {
        super(elem, props);

        this.element = $(elem);

        this.grid = new jsGrid(
            this.element,
            props,
            (e: HTMLElement, a:string,t:string) => this.rowClick(e, a,t),
            (elem: HTMLElement, grid:jsGrid, selected: string[]) => this.selectedActionClick(elem, grid, selected)
        );
        (this.grid as any).setSelectedChangeCallback((ids:any) => {
            this.selectedChange(ids);
        });
    }

    public refresh(): void {
        this.grid.refresh();
    }

    public addSelectedChangeCallback(callback: ((ids: any[]) => void)){
        this.selectedChangeCallbacks.push(callback);
    }

    public selectedChange(ids: any[]){
        console.log("-------- SELECTED CHANGE", ids);
        this.selectedChangeCallbacks.forEach(callback => {
            callback(ids);
        });
    }


    //self.actionCallback.call(this, self, self.selected);
    public selectedActionClick(elem: HTMLElement, grid:jsGrid, selected: string[]){
        console.log("SELECTED CLICK", elem, grid, selected);

        if(selected.length == 0){
            return;
        }

        let button = $(elem);

        let opdialog = new OpenDialog(elem as DceHTMLElement, {
            target: button.data('response-target') ? button.data('response-target') : '#main',
            url: elem.getAttribute("href"),
            bindClick: false
        });

        opdialog.addOnClose((d, e) => {
            if (d.dialogIsNextStep || (!d.getFormBind() || (d.getFormBind() && d.getFormSaved()))) {

                if (button.data('clearSelected')) {
                    grid.clearSelected();
                }

                if(button.data('refresh')){
                    grid.refresh();
                }

                this.grid.refresh();
            }
        });

        let formdata = new FormData();
        selected.forEach(s => {
            formdata.append("ids[]", s);
        })

        opdialog.loadDialogWithPost(formdata);

    }

    onSubComponentInit(component: string, elem: DceHTMLElement) {
        super.onSubComponentInit(component, elem);

        if(component == 'OpenDialog'){
            let od = elem.ext.getComponent('OpenDialog') as OpenDialog;
            od.addOnSavedClose((o, e) => {
                this.grid.refresh();
            });
        }

    }

    public rowClick(elem: HTMLElement, action: string, target: string){

        let opdialog = new OpenDialog(elem as DceHTMLElement, {
            target: target,
            url: action,
            bindClick: false
        });

        opdialog.addOnClose((d, e) => {
            if (d.dialogIsNextStep || (!d.getFormBind() || (d.getFormBind() && d.getFormSaved()))) {
                this.grid.refresh();
            }
        });

        opdialog.loadDialog();

    }

}
